import React, { useState } from 'react';

// Styles & Assets
import styles from './Help.module.css';

// Components
import Modal from '../../UI/Modal/Modal';
import { useTranslation } from 'react-i18next';
import CancelConfirmButtons from '../../UI/CancelConfirmButtons/CancelConfirmButtons';

const Help: React.FC = () => {

    const [showHelp, setShowHelp] = useState(false);

    const { t } = useTranslation();


    const handleClickOpenPdf = async () => {
        try {
            const pdfModule = await import(
                `../../../assets/usermanual/User_Manual_SAD_4_0_${/*i18n.language.toLocaleUpperCase()*/'CA'}.pdf`
            );
            const pdfUrl = pdfModule.default; // Extract the URL
            window.open(pdfUrl, '_blank'); // Open in a new tab
        } catch (error) {
            console.error('Error opening PDF:', error);
        }
    };

    return (
        <>
            <button onClick={handleClickOpenPdf} className={styles.helpButton}>?</button>
            {showHelp &&
                <Modal show={showHelp} setShowModal={setShowHelp}>
                    <div className='dialog'>
                        <CancelConfirmButtons
                            customStyles={{ marginTop: 0 }}
                            onCancel={() => setShowHelp(false)}
                            onConfirm={handleClickOpenPdf}
                            cancelName={t('close') as string}
                            confirmName={t('open_user_manual') as string}
                        />
                    </div>
                </Modal>
            }
        </>
    );
};

export default Help;